import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/Home/index'
import AboutPage from '@/components/About/about'
import Activecompany from '@/components/Activecompany/Activecompany.vue'
import Activeuser from '@/components/Activeuser/index.vue'
import Terms from '@/components/TermsConditions/Terms.vue'
import Contact from '@/components/Contact/Contact.vue'

Vue.use(Router)

export default new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            name: 'HomePage',
            component: HomePage
        },
        {
            path: '/about',
            name: 'About',
            component: AboutPage
        },
        {
            path : '/activecompany/:action?',
            name : 'Activecompany',
            component: Activecompany
        },
        {
            path : '/activeuser/:action?',
            name : 'Activeuser',
            component: Activeuser
        },
        {
            path : '/terms',
            name : 'terms',
            component: Terms
        },,
        {
            path : '/contact',
            name : 'contact',
            component: Contact
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js